<!-- eslint-disable vue/no-use-v-if-with-v-for -->
<template>
  <b-card>
    <template #header>
      <h4 class="mb-0">
        {{ contractData.name }}
      </h4>
      <b-button
        v-b-modal.contract-add-new
        variant="primary"
        style="text-transform: capitalize"
      >
        {{ $t('edit') }}
      </b-button>
    </template>
    <b-row>
      <b-col
        cols="6"
        class="d-flex flex-column"
      >
        <div class="d-flex flex-column">
          <div class="mb-1">
            <p class="card-text">
              {{ $t('created_at') + ": " + contractData.created.toDate().toLocaleString('fi', {
                year: 'numeric', month: 'numeric', day: 'numeric'
              })
              }}
            </p>
          </div>
        </div>
      </b-col>

      <!-- Right Col: Table -->
      <b-col
        cols="6"
      >
        <table class="mt-4 mt-xl-0 w-100">
          <template v-if="contractData.price && Object.keys(contractData.price).length > 0">
            <tr v-if="appConfig.type === 'hw-admin'">
              <th class="pb-50">
                <span class="font-weight-bolder">{{ $t('contract.labels.price') }}:</span>
              </th>
            </tr>
            <tr
              v-for="key in Object.keys(contractData.price)"
              v-if="appConfig.type === 'hw-admin'"
              :key="`price-${key}`"
            >
              <th class="pb-50">
                <span class="font-weight-normal text-capitalize ml-1">{{ key }}:</span>
              </th>
              <td class="pb-50 text-capitalize">
                <b-badge variant="primary">
                  {{ contractData.price[key] }} €
                </b-badge>
              </td>
            </tr>
          </template>

          <template v-if="contractData.salary && Object.keys(contractData.salary).length > 0">
            <span class="font-weight-bolder">{{ $t('contract.labels.salary') }}</span>
            <div
              v-for="key in Object.keys(contractData.salary)"
              :key="`salary-${key}`"
            >
              <b-badge class="text-capitalize" style="margin-block: 5px;">
                {{ `${key}: ${contractData.salary[key]}` }} €
              </b-badge>
            </div>
          </template>
        </table>
      </b-col>
    </b-row>
    <contract-add-new
      :doc-item="docItem"
      @create-or-update-contract="data => $emit('update-contract', data)"
    />
  </b-card>
</template>

<script>
import {
  BButton, BCard, BRow, BCol, BBadge,
} from 'bootstrap-vue'
import ContractAddNew from '../contract-list/ContractAddNew.vue'

export default {
  components: {
    BButton,
    BCard,
    BRow,
    BCol,
    BBadge,
    ContractAddNew,
  },
  props: {
    contractData: {
      type: Object,
      required: true,
    },
  },
  computed: {
    docItem() {
      return this.contractData
    },
    appConfig() {
      return this.$store.state.app.appConfig || {}
    },
  },
}
</script>

<style></style>
